import { gql } from "@apollo/client";

export const AddProjectExt = gql`
  mutation AddProjectExt(
    $token: String!
    $customerID: ID!
    $ldgrID: ID!
    $projectID: ID!
    $user_details: SubscribedUser!
    $input: CreateAtsAcLdgrProjectExt!
  ) {
    AddProjectExt(
      token: $token
      customerID: $customerID
      ldgrID: $ldgrID
      projectID: $projectID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;

export const UpdateProjectExt = gql`
  mutation UpdateProjectExt(
    $token: String!
    $customerID: ID!
    $projectExtID: ID!
    $user_details: SubscribedUser!
    $input: UpdateAtsAcLdgrProjectExt!
  ) {
    UpdateProjectExt(
      token: $token
      customerID: $customerID
      projectExtID: $projectExtID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;

export const DeleteProjectExt = gql`
  mutation DeleteProjectExt(
    $token: String!
    $customerID: ID!
    $projectExtID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteProjectExt(
      token: $token
      customerID: $customerID
      projectExtID: $projectExtID
      user_details: $user_details
    )
  }
`;


















